var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import moment from 'moment-timezone';
import { MedicationExpiry, MedicationStatus } from '../Contracts/MedicationModels';
import { ValidDateFormats } from './DateUtilities';
import { capitalize, lowerCase } from 'lodash';
// 1 day = tomorrow
// 1 week = same day next week
// 0 day is valid
export var expiryStatusFromDate = function (date) {
    if (date === null)
        return MedicationExpiry.NoExpiry;
    var expiryDate = moment(date, ValidDateFormats.IsoFormat).endOf('day');
    var diff = moment().endOf('day').diff(expiryDate, 'days');
    if (diff >= 0)
        return MedicationExpiry.Expired;
    if (diff >= -7)
        return MedicationExpiry.AboutToExpire;
    return MedicationExpiry.InDate;
};
export var groupData = function (items) {
    var e_1, _a;
    var groupings = new Map();
    var allGroupings = items.map(function (value) { return value.grouping; });
    var uniqueGroupings = __spreadArray([], __read(new Set(allGroupings)), false);
    var _loop_1 = function (grouping) {
        groupings.set(capitalize(lowerCase(grouping)), items.filter(function (e) { return grouping === e.grouping; }));
    };
    try {
        for (var uniqueGroupings_1 = __values(uniqueGroupings), uniqueGroupings_1_1 = uniqueGroupings_1.next(); !uniqueGroupings_1_1.done; uniqueGroupings_1_1 = uniqueGroupings_1.next()) {
            var grouping = uniqueGroupings_1_1.value;
            _loop_1(grouping);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (uniqueGroupings_1_1 && !uniqueGroupings_1_1.done && (_a = uniqueGroupings_1.return)) _a.call(uniqueGroupings_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return groupings;
};
export var isInactiveMedicationStatus = function (status) {
    return status === MedicationStatus.Stopped || status === MedicationStatus.EnteredInError;
};
